import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { Link } from "react-router-dom";
import Completion from "../common/Completion";
import MypageTextField from "../../../ui/MypageTextField";
import {
  validateMinlength,
  validateConfirm,
  validateHalfAlphaNum,
} from "../../../../utils/validate";
import {
  getMypageUser,
  postUpdateUserPassword,
} from "../../../../services/apiStudent";

const UpdatePassword = () => {
  // 完了画面かどうかのフラグ
  const [isCompFlg, setIsCompFlg] = useState(false);

  const {
    register,
    handleSubmit,
    setValue,
    setError,
    watch,
    formState: { errors },
  } = useForm();

  // 変更を確定するボタン
  const onSubmit = async (data) => {
    const result = await postUpdateUserPassword(data);
    if (!result) return;
    if (result.is_valid) {
      setIsCompFlg(true);
    } else {
      // エラーメッセージ
      for (var err of result.err_list) {
        setError(err.name, { message: err.msg });
      }
    }
    scrollTop();
  };

  // スクロールを一番上に移動
  const scrollTop = () => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "instant",
    });
  };

  // 初回レンダリング
  useEffect(() => {
    (async function () {
      const data = await getMypageUser();
      if (data == undefined || !data) return;
      // 学生番号(ログインID)、更新日時をセット
      setValue("login_id", data.login_id);
      setValue("updated_at", data.app_user_updated_at);
    })();
  }, []);

  return (
    <>
      {isCompFlg ? (
        <Completion
          title="パスワードの変更完了"
          explanation="パスワードの変更を完了致しました。"
          link="/mypage/user"
          btntext="ユーザー情報の確認・変更ページに戻る"
        />
      ) : (
        <div className="l-page-right">
          <div className="l-page-con">
            <h1 className="p-heading01">パスワードの変更</h1>
            <p className="mt-5 mb-5">
              パスワードは8～12文字の半角英数文字で設定可能です。
            </p>
            <form
              action=""
              className="p-login-form"
              onSubmit={handleSubmit(onSubmit)}
            >
              <div className="p-login-con__form">
                <MypageTextField
                  type="password"
                  name="current_password"
                  label="現在のパスワード"
                  maxLength={12}
                  register={register}
                  errors={errors}
                  watch={watch}
                  required={true}
                  placeholder="現在のパスワード"
                  autocomplete="current-password"
                />
                <MypageTextField
                  type="password"
                  name="password"
                  label="新しいパスワード"
                  maxLength={12}
                  register={register}
                  validation={{
                    ...validateMinlength(8),
                    ...validateHalfAlphaNum(),
                  }}
                  errors={errors}
                  watch={watch}
                  required={true}
                  placeholder="新しいパスワード"
                  autocomplete="new-password"
                />
                <MypageTextField
                  type="password"
                  name="password2"
                  label="新しいパスワード(確認用)"
                  maxLength={12}
                  register={register}
                  validation={{
                    ...validateMinlength(8),
                    ...validateHalfAlphaNum(),
                    ...validateConfirm(
                      "password",
                      "password2",
                      "新しいパスワード"
                    ),
                  }}
                  errors={errors}
                  watch={watch}
                  required={true}
                  placeholder="新しいパスワード(確認用)"
                  autocomplete="new-password"
                />
                <div hidden>
                  <input
                    type="text"
                    name="login_id"
                    {...register("login_id", {})}
                  />
                  <input
                    type="text"
                    name="updated_at"
                    {...register("updated_at")}
                  />
                </div>
                <div className="p-login-form__btnbox">
                  <div className="p-login-form__returnbtn">
                    <Link to="/mypage/user">
                      <input
                        className="p-login-form__link"
                        type="button"
                        value="変更を取り消す"
                      />
                    </Link>
                  </div>
                  <input
                    className="p-login-form__link"
                    type="submit"
                    value="変更を確定する"
                  />
                </div>
              </div>
            </form>
          </div>
        </div>
      )}
    </>
  );
};

export default UpdatePassword;
